<template>
		<header>
			<h1>Типы транспорта</h1>
			<div class="actions">
				<VLink
					@click="openCard()"
          material="add"
				>
					Добавить тип транспорта
				</VLink>
			</div>
		</header>

		<div class="group-list">
			<article
				v-for="item in items"
				:key="item.id"
				class="group-list-item"
				:class="{ selected: (selected?.id ?? null) === item.id }"
				@click="changeSelected(item)"
			>
				<span
					:title="item.name"
				>
					{{ item.name }}
				</span>

				<VLink
					@click="openCard(item, $event)"
          material="edit"
				>
				</VLink>
			</article>
		</div>
</template>

<script lang="ts">

import VehicleType         from '@/domains/VehicleTypes/VehicleType';
import VehicleTypesService from '@/domains/VehicleTypes/VehicleTypesService';

export default defineComponent({
	name: 'VehicleTypesRegistry',

	props: {
		modelValue: {
			type:    Object as () => VehicleType | null,
			default: null,
		},
	},

	emits: ['update:modelValue'],

	data() {
		return {
			items:    [] as VehicleType[],
			selected: this.modelValue,
		};
	},

	watch: {
		modelValue(value: VehicleType | null) {
			this.selected = value;
		},
	},

	async mounted() {
		await this.refresh();
	},

	methods: {
		async refresh(): Promise<void> {
			const { data } = await VehicleTypesService.getList();

			this.items = data;

			// У транспорта всегда есть тип — список не должен оставаться без выбора.
			// Если выбранный тип исчез (или ничего не выбрано) — выбираем первый.
			const selectedId = this.selected?.id ?? null;
			const stillExists = selectedId !== null
				&& data.some(type => type.id === selectedId);

			if (!stillExists) {
				if (data.length > 0) {
					this.changeSelected(data[0]);
				} else {
					this.selected = null;
					this.$emit('update:modelValue', null);
				}
			}
		},

		changeSelected(vehicleType: VehicleType): void {
			this.selected = vehicleType;
			this.$emit('update:modelValue', vehicleType);
		},

		async openCard(entity: VehicleType | null = null, event?: MouseEvent): void {
			event?.stopPropagation();

      const result = await VehicleTypesService.showVehicleTypeCard(entity);

      if (result) {
        await this.refresh();
      }
		},
	},
});
</script>
